module.exports = __webpack_public_path__ + "static/media/howItWork1.b33f082c.png";